import { useState } from 'react';

export const useGetBlogs = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async ({limit, skip = 0}) => {
    setIsLoading(true)

    try {
      const response = await fetch(`/api/getEntries`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content_type: 'blogPost',
          order: '-fields.datePublished',
          options: { subscriptionRequired: true, match: "Beyond" },
          limit: limit,
          skip: skip,
        }),
      })
      const json = await response.json();
      return json
    } catch (err) {
      setError(err)
      throw "Something went wrong. Please try again later."
    } finally {
      setIsLoading(false)
    }
  };

  return { fetchData, isLoading, error };
}
